import { Navigate, useSearchParams } from 'react-router-dom';

/** Maps `/mtc+/details-tabs?projectId=...` to `/mtc+/project-details/:projectId` (MTC+ layout). */
const MTCDetailsTabsRedirect = () => {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId')?.trim();
  if (!projectId) {
    return <Navigate to="/mtc+/all-projects" replace />;
  }
  return <Navigate to={`/mtc+/project-details/${encodeURIComponent(projectId)}`} replace />;
};

export default MTCDetailsTabsRedirect;
